import { render, staticRenderFns } from "./ClientFilter.vue?vue&type=template&id=4c58c4f4&scoped=true&"
import script from "./ClientFilter.vue?vue&type=script&lang=js&"
export * from "./ClientFilter.vue?vue&type=script&lang=js&"
import style0 from "./ClientFilter.vue?vue&type=style&index=0&id=4c58c4f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c58c4f4",
  null
  
)

export default component.exports